module.exports = __webpack_public_path__ + "images/emoji/confetti_ball.bea649fd6d79fbd07c47.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/confetti_ball.png
// module id = x0vb
// module chunks = 2